import React from 'react';
import { useIntl, defineMessages } from 'react-intl';

import { SelectInput } from 'io-sanita-theme/components';
import { Input } from 'design-react-kit';

const messages = defineMessages({
  search_title: {
    id: 'alp_search_title',
    defaultMessage: 'Nome o cognome del medico',
  },
  reparto: {
    id: 'alp_reparto',
    defaultMessage: 'Reparto',
  },
  prestazione: {
    id: 'alp_prestazione',
    defaultMessage: 'Prestazione',
  },
  find: {
    id: 'find',
    defaultMessage: 'Cerca',
  },
});

const SearchBar = ({ filters, setFilters, doSearch, options = {} }) => {
  const intl = useIntl();

  return (
    <div className="search-bar rounded bg-light py-2 px-4 mb-4 mx-lg-4">
      <div className="d-flex search-container align-items-center justify-content-center flex-wrap">
        <div className="filter-wrapper text-filter">
          <Input
            id="title"
            value={filters['title'] ?? ''}
            label={intl.formatMessage(messages.search_title)}
            type="text"
            onChange={(e) => {
              setFilters({
                ...filters,
                title: e.currentTarget.value,
                searchTitle: null,
              });
            }}
          />
        </div>

        <div className="filter-wrapper select-filter">
          <SelectInput
            id="uo_riferimento"
            value={filters['uo_riferimento'] ?? ''}
            placeholder={intl.formatMessage(messages.reparto)}
            onChange={(opt) => {
              setFilters({ ...filters, uo_riferimento: opt });
            }}
            options={options.uo ?? []}
            isClearable={true}
            isSearchable={true}
          />
        </div>

        <div className="filter-wrapper text-filter">
          <Input
            id="prestazione"
            value={filters['prestazione'] ?? ''}
            label={intl.formatMessage(messages.prestazione)}
            type="text"
            onChange={(e) => {
              setFilters({
                ...filters,
                prestazione: e.currentTarget.value,
              });
            }}
          />
        </div>

        {/* <Button
          color="primary"
          icon={false}
          tag="button"
          onClick={() => {
            doSearch(1, filters);
          }}
          aria-controls="alp-results"
        >
          {intl.formatMessage(messages.find)}
        </Button> */}
      </div>
    </div>
  );
};

export default SearchBar;
